import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://pagos.indigo33.shop/cart/63856290595185:1';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  onClick?: () => void;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  onClick,
  href = CHECKOUT_URL,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-display font-bold text-lg md:text-xl px-8 py-4 rounded-xl transition-all duration-200 ease-in-out';
  const variants = {
    primary: 'bg-coral text-white shadow-solid hover:shadow-solid-hover hover:translate-y-[2px] hover:translate-x-[2px]',
    secondary: 'bg-gold text-dark shadow-solid hover:shadow-solid-hover hover:translate-y-[2px] hover:translate-x-[2px]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: redirect to checkout
      window.location.href = href;
    }
  };
  return <motion.button whileTap={{
    scale: 0.98
  }} className={cn(`${baseStyles} ${variants[variant]} ${widthClass} ${className}`, 'text-[14px]')} onClick={handleClick} {...props} data-id="element-298">
      {children}
    </motion.button>;
}